module.exports = __webpack_public_path__ + "img/rocket_man_transparent.3445f2dc.webp";